import {
  Heading,
  Illustration,
  IllustrationName,
  Span,
} from '@pandiafi/design-system'
import { t } from 'i18next'
import React from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  illustration?: IllustrationName
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  illustration = 'empty-letter',
}) => {
  return (
    <div className="flex flex-col gap-5 items-center">
      <Illustration
        name={illustration}
        className="mb-6 max-h-48 h-48"
        alt={t('common:alt.illustration')}
      />

      <Heading className="text-center mb-5" element="h1" size="m">
        {title}
      </Heading>

      {description && <Span className="text-center mb-5">{description}</Span>}
    </div>
  )
}
